var $ = require('jQuery');
var AttachmentTypes = require('../../lib/attachment-types.js');
var checkboxes = require('../../lib/checkboxes.js');
var VisibilityMatrix = require('./visibility-matrix.js');
var FormDisabler = require('../../lib/form-disabler.js');

module.exports = function () {
  // Mode options
  var toggleOptions = function () {
    var radioButtons = $('input:radio[name="mode"]');
    var mode;

    if (radioButtons.length) {
      mode = radioButtons.filter(':checked').val();
    } else {
      mode = $('input[name="mode"]').val();
    }

    $('.options').addClass('hidden');
    var options = $('.' + mode + '-options');

    if (options.length) {
      options.removeClass('hidden');
      $('#rules').removeClass('hidden');
    }

    $('.only-options').removeClass('hidden');

    $('.only-options').filter(
      function () {
        return $(this).find('.options').not('.hidden').length === 0;
      }
    ).addClass('hidden');

  };

  $('input:radio[name="mode"]').click(toggleOptions);
  toggleOptions();

  // Initialise attachment types toggles
  new AttachmentTypes();

  // visibility matrix
  new VisibilityMatrix();

  // Conditional checkboxes
  checkboxes.conditionalEnable('#abstention', '#comment-on-abstention');
  checkboxes.conditionalEnable('#comments', '#comment-required');
  checkboxes.conditionalEnable('#comment-scores', '#comment-scores-required');
  checkboxes.conditionalEnable('#duplicate-entry-count', '#duplicate-entry-list');

  (new FormDisabler()).disableForm($('.form-disabled'));
};
